import * as React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import theme from '@theme/Theme'

interface Props {
  disabled?: boolean
  iconOnTheRight?: boolean
  label: string
  onClick: () => void
  value: boolean
  partial?: boolean
  icon?: {
    name: IconName
    color: string
  }
  info?: number
  fontBold?: boolean
}

const CheckboxComponent = ({
  disabled = false,
  iconOnTheRight = false,
  label,
  onClick,
  value,
  partial,
  icon,
  info,
  fontBold = false,
}: Props) => {
  return (
    <Container disabled={disabled} iconOnTheRight={iconOnTheRight} activeOpacity={0.9} onPress={onClick}>
      <Icon
        name={value ? 'checkbox_checked' : partial ? 'checkbox_partial' : 'checkbox_unchecked'}
        size={24}
        color={disabled || (!value && !partial) ? theme.colors.disable : theme.colors.primary}
      />
      {info && (
        <InfoContainer>
          <InfoBuble>
            <Info>{info}</Info>
          </InfoBuble>
        </InfoContainer>
      )}
      <Label iconOnTheRight={iconOnTheRight} disabled={disabled} info={!!info} fontBold={fontBold}>
        {label}
      </Label>
      {icon && (
        <IconContainer>
          <Icon name={icon.name} size={16} color={icon.color} />
        </IconContainer>
      )}
    </Container>
  )
}

export default CheckboxComponent

const Container = styled(TouchableOpacity)<{ iconOnTheRight: boolean }>`
  flex-direction: ${(props) => (props.iconOnTheRight ? 'row-reverse' : 'row')};
  align-items: center;
`
const Label = styled(Text)<{ iconOnTheRight: boolean; disabled: boolean; info?: boolean; fontBold?: boolean }>`
  ${(props) => (props.fontBold ? props.theme.fonts.Callout : props.theme.fonts.Body)};
  ${(props) => props.fontBold && `font-size: 16px;`};
  color: ${(props) => (props.disabled ? props.theme.colors.disable : props.theme.colors.primaryText)};
  flex: ${(props) => (props.info ? 'none' : 1)};
  padding: ${(props) => (props.iconOnTheRight ? `0px 10px 0 0px` : `0px 0 0 10px`)};
`
const InfoContainer = styled(View)`
  flex: 1;
  justify-content: flex-start;
`
const InfoBuble = styled(View)`
  background-color: ${(props) => props.theme.colors.primaryFocused};
  height: 24px;
  width: 24px;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  padding: 5px;
`
const IconContainer = styled(View)`
  margin-right: 9px;
`

const Info = styled(Text)`
  ${(props) => props.theme.fonts.Caption1};
`
